module.exports = __webpack_public_path__ + "static/media/plan-D3b-desktop-tc.6486c551.png";